import ApiClient from './apiClient';

export const fetchLoyaltyItems = async (keywords?: string, status?:string, page?: number) => {
  const response = await ApiClient.getInstance().get({
    url: 'wallet/getloyaltyitems',
    params: {
      keywords,
      status,
      page: page || 1,
    },
  });

  return response.data;
};
